import { render, staticRenderFns } from "./ColourAutocomplete.vue?vue&type=template&id=83b65d44&scoped=true"
import script from "./ColourAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./ColourAutocomplete.ts?vue&type=script&lang=ts&external"
import style0 from "./ColourAutocomplete.scss?vue&type=style&index=0&id=83b65d44&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b65d44",
  null
  
)

export default component.exports